import { mergeClasses } from '@fluentui/react-components';
import { Checkmark12Regular, Dismiss12Regular } from '@fluentui/react-icons';
import { usePillBadgeStyles } from './PillBadge.styles';

const humanizeCode = (code: string): string =>
  code
    .replace(/[-_]/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase())
    .trim();

export interface PillBadgeProps {
  amenityCode?: string;
  label?: string;
  available: boolean;
  className?: string;
  availableText?: string;
  unavailableText?: string;
  ariaLabel?: string;
}

export const PillBadge = ({
  amenityCode,
  label,
  available,
  className,
  availableText = 'available',
  unavailableText = 'unavailable',
  ariaLabel,
}: PillBadgeProps) => {
  const styles = usePillBadgeStyles();

  const resolvedLabel = label ?? (amenityCode ? humanizeCode(amenityCode) : '');

  const computedAriaLabel =
    ariaLabel ?? `${resolvedLabel}: ${available ? availableText : unavailableText}`;

  return (
    <span
      role="img"
      aria-label={computedAriaLabel}
      className={mergeClasses(
        styles.root,
        available ? styles.available : styles.unavailable,
        className
      )}
    >
      <span>{resolvedLabel}</span>
      <span className={styles.statusIcon}>
        {available ? <Checkmark12Regular /> : <Dismiss12Regular />}
      </span>
    </span>
  );
};

PillBadge.displayName = 'PillBadge';
